import { FeatureFlag } from "../Interfaces";

/**
 * @function
 * @description - To merge default feature flag array and api responce array
 * @param defaultArray - Hardcoded array
 * @param featureFlag - Features with updated values
 * @returns 
 */
export const mergeFeatureFlags = (
  defaultArray: Array<FeatureFlag>,
  featureFlag: Array<FeatureFlag>
) : Array<FeatureFlag> => {
  try {
    const mergedArray = [...defaultArray, ...featureFlag].reduce(
      (acc: Array<FeatureFlag>, current) => {
        const existingFeature = acc.find(
          (item: FeatureFlag) => item.featureName === current.featureName
        );

        if (existingFeature) {
          Object.assign(existingFeature, current);
        } else {
          acc.push(current);
        }
        return acc;
      },
      []
    );
    return mergedArray;
  } catch {
    return defaultArray;
  }
};
